import { useContext } from 'react'

import CreateApiClientContext from '@dc-shared-web/providers/CreateApiClientContext'

const { Provider, context } = CreateApiClientContext({
  withCredentials: true,
})

export const AxiosProvider = Provider

export const useAxiosContext = () => useContext(context)
